import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainyLight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRainyLight"><Path d="M11.25 15.75L10.25 17.75M13.5 18.5L12.5 20.5M9.5 15.5H16C18.4853 15.5 20.5 13.4853 20.5 11C20.5 8.51472 18.4853 6.5 16 6.5C15.5805 6.5 15.1744 6.5574 14.7892 6.66477C13.7772 4.78089 11.7882 3.5 9.5 3.5C6.18629 3.5 3.5 6.18629 3.5 9.5C3.5 12.8137 6.18629 15.5 9.5 15.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRainyLight;
